import { Component, HostBinding } from '@angular/core';
import { ContentBlock, ContentBlockType } from '@tytapp/content';
import { ContentBlockEditorComponent } from '@tytapp/content/content-block-editor-component';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';

export interface AnchorBlock extends ContentBlock {
    type: 'anchor';
    isPreview?: boolean;
}

@Component({
    template: `
        <ng-container *ngIf="block.isPreview">
            <div>
                <mat-icon>anchor</mat-icon>
            </div>
            <em>This block does nothing, which is useful for managing floating blocks</em>
        </ng-container>
    `,
    styles: [`
        :host.preview {
            text-align: center;
            width: 12em;
            display: flex;
            flex-direction: column;
            gap: 0.5em;

            mat-icon {
                width: 48px;
                height: 48px;
                font-size: 48px;
            }

            em {
                opacity: 0.7;
            }
        }
    `]
})
export class ViewComponent extends ContentBlockViewComponent<AnchorBlock> {
    @HostBinding('class.preview') get isPreview() { return this.block?.isPreview ?? false; }
}

@Component({
    template: `
    <mat-icon>anchor</mat-icon>
    `
})
export class EditorComponent extends ContentBlockEditorComponent<AnchorBlock> {
}

export const ANCHOR_BLOCK_TYPE: ContentBlockType<AnchorBlock> = {
    id: 'anchor',
    label: 'Anchor',
    icon: 'title',
    preview: {
        isPreview: true
    },
    previewSettings: {
        verticalAlign: 'center',
        horizontalAlign: 'center'
    },
    editorComponent: EditorComponent,
    viewComponent: ViewComponent
};
